import React, {
	memo,
	useState,
	useMemo,
	useEffect,
	useCallback,
	useRef,
} from "react";
import { motion } from "framer-motion";
import "./surface-preview.css";
import anim from "../../utils/anim";
import useData from "../../hooks/useData";
import useDimensions from "../../hooks/useDimensions";

const SurfacePreview = memo(
	({ Component, remoteKey = "", moduleDataMapper }) => {
		const data = useData();

		const [moduleData, setModuleData] = useState(data);
		const [showFullCard, setShowFullCard] = useState(true);

		const rootRef = useRef(null);
		const { innerHeight, offsetTop } = useDimensions();
		const onClose = useCallback(() => {
			return;
		}, []);

		const defaultModuleProps = useMemo(
			() => ({
				surfaceData: moduleData[remoteKey],
				data: moduleData,
				idx: -1,
				active: true,
				preview: true,
				handleSurfaceClose: onClose,
				handleOrchestratorClose: onClose,
				showFullCard,
				rootRef,
			}),
			[moduleData, onClose, showFullCard, remoteKey]
		);
		const handleScroll = useCallback(() => {
			if (!rootRef?.current) {
				return;
			}
			const scroll = rootRef.current.scrollTop;
			if (scroll > 10) {
				setShowFullCard(false);
			} else {
				setShowFullCard(true);
			}
		}, []);

		useEffect(() => {
			if (data?.[remoteKey]) {
				return;
			}
			setModuleData((moduleData) => ({
				...moduleData,
				[remoteKey]: moduleDataMapper(data),
			}));
		}, [data, remoteKey, moduleDataMapper]);

		if (!moduleData?.[remoteKey]) {
			return null;
		}

		return (
			<motion.section
				className="surface-preview-container"
				style={{
					top: `${offsetTop}px`,
					height: `${innerHeight}px`,
					// backgroundColor: customColor
					// 	? customColor
					// 	: // desktop
					// 	  // 	? `${customColor}ee`
					// 	  // 	: customColor
					// 	  "auto",
				}}
				ref={rootRef}
				onScroll={handleScroll}
				variants={anim.surfaceManager}
				initial="initial"
				animate="animate"
				exit="exit"
			>
				<Component {...defaultModuleProps} />
			</motion.section>
		);
	}
);

export default SurfacePreview;
